/*
 * @Author: Bing Ni nibing1220@qq.com
 * @Date: 2024-08-07 16:12:41
 * @LastEditors: Bing Ni nibing1220@qq.com
 * @LastEditTime: 2024-08-09 16:03:25
 * @FilePath: /fleximagegenerator/src/context/UserContext.jsx
 * @description: 
 */
"use client";
import { useState, useEffect, createContext, useContext, useRef} from "react";
import { toast } from "sonner";
import { getSupabaseClient } from "@/lib/supabaseClient";
import { fetchUserInfo, fetchUserInfoDelayed, preloadUserInfo } from "@/utils/userService";
import { logger } from "@/lib/logger";

// 用户上下文配置

export const UserContext = createContext({
  user: null,
  setUser: () => {},
  fetchUserInfo: () => {},
  userLoading: true
});

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const supabase = getSupabaseClient();

  const fetchUserInfoFromAPI = async function () {
    logger.info("[UserContext] Fetching user info from API...");
    
    try {
      const data = await fetchUserInfo();
      
      // userService已经处理了错误，直接使用返回的数据
      setUser(data.user);
      setHasError(false);
      logger.info("[UserContext] User info fetched successfully");
      
    } catch (fetchError) {
      // 只有在userService抛出错误时才执行这里
      logger.error("Unexpected error in fetchUserInfoFromAPI:", fetchError);
      setHasError(true);
      setUser(null);
    } finally {
      setUserLoading(false);
    }
  };

  // 使用 ref 来追踪是否已经发起过请求，防止重复获取用户信息
  const hasFetched = useRef(false);

  // 组件挂载时延迟获取用户信息，避免阻塞首屏渲染
  useEffect(() => {
    if (!hasFetched.current) {
      logger.info("[UserContext] Initial mount, scheduling delayed user info fetch...");
      hasFetched.current = true;
      
      // 延迟1秒获取用户信息，避免阻塞首屏渲染
      const timer = setTimeout(() => {
        fetchUserInfoFromAPI();
      }, 1000);
      
      // 同时在后台预加载用户信息
      preloadUserInfo();
      
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, fetchUserInfo: fetchUserInfoFromAPI, userLoading }}>
      {children}
    </UserContext.Provider>
  );
};


export const useUserContext = () => useContext(UserContext)